import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { CustomProductTechnicalCharcComponent } from './custom-product-technical-charc.component';

@NgModule({
    declarations: [CustomProductTechnicalCharcComponent],
    exports: [CustomProductTechnicalCharcComponent],
    imports: [
        CommonModule,
        I18nModule,
        ConfigModule.withConfig({
            cmsComponents: {
                ProductTechnicalCharacsTabComponent: {
                    component: CustomProductTechnicalCharcComponent,
                },
            },
        } as CmsConfig),
    ]
})
export class CustomProductTechnicalCharcModule {}
